import React from 'react';
import { Flex, Heading, Box, Image } from '@chakra-ui/react';
import { Card, Spinner, Button } from 'components/lib';
import { useMsal } from '@azure/msal-react';
import { redirectRequest } from 'lib/msal';
import history from 'history/browser';

export function Login() {
    const { instance, inProgress } = useMsal();

    return (
        <Flex
            height="100vh"
            width="full"
            justify="center"
            align="center"
            flexDir="column"
            bg="ecp.50">
            <Card bg="white" boxShadow="2xl" width="sm" rounded="1rem" p="8">
                <Flex align="center" justify="center" mb="8">
                    <Image
                        src="/logo.png"
                        alt="logo"
                        w="auto"
                        height="16"
                        marginRight="4"
                        ignoreFallback={true}
                    />
                    <Heading textAlign="center" color="ecp.900">
                        ECP Support
                    </Heading>
                </Flex>
                {inProgress === 'login' ? (
                    <Box textAlign="center">
                        <Spinner />
                    </Box>
                ) : (
                    <Button
                        variant="outline"
                        size="lg"
                        width="full"
                        onClick={() =>
                            instance
                                .loginRedirect(redirectRequest)
                                .then(res => {
                                    history.push('/');
                                    window.location.reload();
                                })
                                .catch(e => console.log(e))
                        }>
                        Log in
                    </Button>
                )}
            </Card>
        </Flex>
    );
}

export default Login;
